module.exports = __webpack_public_path__ + "img/swiper-bg.2bbdd1ae.png";